/* CIENTO editorial theme — storefront interactions. No external dependencies. */
(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const toast = (message) => {
    const element = $('#cart-toast');
    if (!element) return;
    element.textContent = message;
    element.hidden = false;
    clearTimeout(window.cientoToastTimeout);
    window.cientoToastTimeout = setTimeout(() => { element.hidden = true; }, 4000);
  };
  const rootPath = window.Shopify?.routes?.root || '/';
  const cartAddPath = `${rootPath}cart/add.js`;
  const cartPath = `${rootPath}cart`;
  const refreshCartCount = async () => {
    try {
      const result = await fetch(`${rootPath}cart.js`, { credentials: 'same-origin' });
      if (!result.ok) return;
      const cart = await result.json();
      $$('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
      $('.cart-icon')?.setAttribute('aria-label', `Varukorg med ${cart.item_count} produkter`);
    } catch (err) { /* Native forms remain available */ }
  };

  function initHeader() {
    const openButton = $('[data-mobile-menu-open]');
    const closeButton = $('[data-mobile-menu-close]');
    const menu = $('#mobile-menu');
    const backdrop = $('[data-mobile-backdrop]');
    if (openButton && menu && backdrop) {
      const toggle = (show) => {
        menu.classList.toggle('is-open', show);
        menu.setAttribute('aria-hidden', String(!show));
        menu.inert = !show;
        backdrop.hidden = !show;
        openButton.setAttribute('aria-expanded', String(show));
        document.body.style.overflow = show ? 'hidden' : '';
        if (show) closeButton?.focus(); else openButton.focus();
      };
      openButton.addEventListener('click', () => toggle(true));
      closeButton?.addEventListener('click', () => toggle(false));
      backdrop.addEventListener('click', () => toggle(false));
      document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu.classList.contains('is-open')) toggle(false); });
    }
    const searchButton = $('[data-search-toggle]');
    const search = $('#header-search');
    searchButton?.addEventListener('click', () => {
      if (!search) return;
      search.hidden = !search.hidden;
      searchButton.setAttribute('aria-expanded', String(!search.hidden));
      if (!search.hidden) $('input[type="search"]', search)?.focus();
    });
  }
  function initProductForms() {
    $$('[data-ajax-add]').forEach(form => {
      if (form.dataset.ajaxInitialized) return;
      form.dataset.ajaxInitialized = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = $('button[type="submit"]', form);
        if (!button || button.disabled) return;
        const oldText = button.innerHTML;
        button.disabled = true;
        button.textContent = 'LÄGGER TILL…';
        try {
          const response = await fetch(cartAddPath, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }, credentials: 'same-origin' });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Det gick inte att lägga till produkten.');
          await refreshCartCount();
          toast('Tillagd i varukorgen!');
        } catch (error) { toast(error.message || 'Ett fel inträffade. Försök igen.'); }
        finally { button.disabled = false; button.innerHTML = oldText; }
      });
    });
    $$('[data-qty-control]').forEach(control => {
      const input = $('input[type="number"]', control);
      if (!input) return;
      $('[data-qty-plus]', control)?.addEventListener('click', () => { input.value = Math.min(99, Math.max(1, Number(input.value) || 1) + 1); });
      $('[data-qty-minus]', control)?.addEventListener('click', () => { input.value = Math.max(1, (Number(input.value) || 1) - 1); });
    });
    $$('[data-product-page]').forEach(page => {
      $$('[data-product-thumb]', page).forEach(button => {
        button.addEventListener('click', () => {
          const image = $('[data-product-main-image] img', page);
          if (image) { image.src = button.dataset.src; image.srcset = ''; image.alt = button.dataset.alt || ''; }
          $$('[data-product-thumb]', page).forEach(item => item.removeAttribute('aria-current'));
          button.setAttribute('aria-current', 'true');
        });
      });
      $('[data-product-variant]', page)?.addEventListener('change', event => {
        const selected = event.target.selectedOptions[0];
        const price = $('[data-product-price]', page);
        if (price && selected) price.textContent = selected.dataset.price;
      });
    });
  }
  function initBundleBuilder() {
    $$('[data-bundle-builder]').forEach(builder => {
      if (builder.dataset.initialized) return;
      builder.dataset.initialized = 'true';
      // Sold-out fragrances have no stepper: never include them in the interactive state.
      const products = $$('[data-bundle-option]', builder).map(element => ({
        element,
        variantId: Number(element.dataset.variantId),
        title: element.dataset.productTitle || 'Parfym',
        price: Number(element.dataset.price) || 0,
        qty: 0,
        minus: $('[data-bundle-minus]', element),
        plus: $('[data-bundle-plus]', element),
        label: $('[data-bundle-qty]', element)
      })).filter(product => Number.isSafeInteger(product.variantId) && product.variantId > 0 && product.minus && product.plus && product.label);
      const slots = $$('[data-bundle-slot]', builder);
      const count = $('[data-bundle-count]', builder);
      const chosen = $('[data-bundle-selected]', builder);
      const total = $('[data-bundle-total]', builder);
      const regularPrice = $('[data-bundle-regular-price]', builder);
      const priceLabel = $('[data-bundle-price-label]', builder);
      const submit = $('[data-bundle-submit]', builder);
      const feedback = $('[data-bundle-message]', builder);
      if (!submit || !count || !chosen || !total || !regularPrice || !priceLabel || !feedback) return;
      // These are display prices for the bundle selector only; Shopify checkout prices
      // must be configured with a matching discount/bundle product separately.
      const singlePrice = Number(builder.dataset.bundleOnePrice) || 29900;
      const packagePrice = Number(builder.dataset.bundlePackagePrice) || 59800;
      const formatMoney = cents => {
        const amount = new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 2 }).format(cents / 100);
        return `${amount} kr`;
      };
      const selectedCount = () => products.reduce((sum, product) => sum + product.qty, 0);
      const update = () => {
        const selection = products.flatMap(product => Array(product.qty).fill(product));
        const quantity = selection.length;
        count.textContent = String(quantity);
        slots.forEach((slot, i) => {
          slot.classList.toggle('selected', i < quantity);
          slot.textContent = i < quantity ? selection[i].title : String(i + 1);
          slot.title = i < quantity ? selection[i].title : `Välj doft ${i + 1}`;
        });
        products.forEach(product => {
          product.label.textContent = String(product.qty);
          product.minus.disabled = product.qty < 1;
          product.plus.disabled = quantity >= 3;
        });
        chosen.replaceChildren();
        if (!quantity) {
          const li = document.createElement('li');
          li.textContent = products.length ? 'Välj tre dofter för att fortsätta.' : 'Inga dofter är tillgängliga just nu.';
          chosen.append(li);
        }
        products.filter(product => product.qty).forEach(product => {
          const li = document.createElement('li');
          li.textContent = `${product.qty} × ${product.title}`;
          chosen.append(li);
        });
        // Price ladder remains 299 / 598 / 598 SEK independently of SKU prices.
        const regularTotal = selection.reduce((sum, product) => sum + product.price, 0);
        const displayPrice = quantity === 0 ? 0 : quantity === 1 ? singlePrice : packagePrice;
        priceLabel.textContent = quantity === 3 ? '3 FÖR 2 · PAKETPRIS' : 'Pris för valda dofter';
        total.textContent = formatMoney(displayPrice);
        regularPrice.hidden = quantity !== 3;
        regularPrice.textContent = quantity === 3 ? formatMoney(regularTotal) : '';
        regularPrice.setAttribute('aria-label', `Ordinarie pris ${formatMoney(regularTotal)}`);
        submit.disabled = quantity !== 3;
        submit.textContent = !products.length
          ? 'TILLFÄLLIGT EJ TILLGÄNGLIGT'
          : quantity === 3
            ? `LÄGG I VARUKORGEN · ${formatMoney(packagePrice).toUpperCase()}`
            : `VÄLJ ${3 - quantity} ${3 - quantity === 1 ? 'DOFT TILL' : 'DOFTER TILL'}`;
      };
      products.forEach(product => {
        product.plus.addEventListener('click', () => {
          if (selectedCount() >= 3) return;
          product.qty += 1;
          feedback.textContent = '';
          update();
        });
        product.minus.addEventListener('click', () => {
          if (product.qty < 1) return;
          product.qty -= 1;
          feedback.textContent = '';
          update();
        });
      });
      submit.addEventListener('click', async () => {
        const items = products.filter(product => product.qty > 0).map(product => ({ id: product.variantId, quantity: product.qty }));
        if (items.reduce((sum, item) => sum + item.quantity, 0) !== 3) return;
        submit.disabled = true;
        submit.textContent = 'LÄGGER TILL I VARUKORGEN…';
        feedback.textContent = '';
        try {
          // Shopify Ajax API accepts multiple variant IDs in one request.
          const response = await fetch(builder.dataset.cartUrl || cartAddPath, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
            credentials: 'same-origin'
          });
          const result = await response.json().catch(() => ({}));
          if (!response.ok) {
            throw new Error(result.description || result.message || 'Kunde inte lägga till alla tre dofter. Kontrollera lagersaldot och försök igen.');
          }
          await refreshCartCount();
          window.location.assign(builder.dataset.cartPageUrl || cartPath);
        } catch (error) {
          update();
          feedback.textContent = error.message || 'Det gick inte att lägga till paketet. Försök igen.';
        }
      });
      update();
    });
  }
  const init = () => { initHeader();initProductForms();initBundleBuilder(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', event => { initProductForms();initBundleBuilder(); });
})();
